import React from "react";
import {
    CrossIcon,
    StyledLabel,
    StyledSelectInput,
    StyledTextInput,
} from "@aureskonnect/react-ui";
import { AvForm, AvGroup } from "availity-reactstrap-validation";
import classnames from "classnames";

import { resetAllPeripherals } from "@pages/Applications/DeviceAssociateModal/store";
import { setIsActionsClicked, setActions } from "./store";

import CashManagementConfiguration from "../../../pages/Applications/DeviceAssociateModal/CashManagementApplicationForm/CashManagementConfiguration";
import { ConfirmationEditMessage } from "@components/Common/ConfirmationEditMessage";
import {
    CustomCardHeader,
    CustomCardBody,
    CustomCardFooter,
} from "@components/Common/CustomCardStyled";
import { ipMatchWord, numberMatchWord } from "@constants/index";

import "../CashManagement/ModalConfigurations/index.css";

import { CustomMainColorButton } from "@components/Common/CustomMainColorButton";
import { CustomSecondaryColorButton } from "@components/Common/CustomSecondaryColorButton";

import { useCashManagementConfigure } from "./useCashManagementConfigure";

type CashManagementType = {
    setIsAddCashManagementClicked: Function;
    setDataIsUpdated: Function;
    isAddCashManagementClicked: boolean;
    editedData: any;
    setEditedData: Function;
    isAddNewCashManagementButtonClicked: boolean;
    shopId: number | string;
    isEdited: boolean;
    setIsEdited: Function;
    setInputDesignation: Function;
    inputDesignation: boolean;
    setInputMarque: Function;
    inputMarque: boolean;
    inputIp: boolean;
    setInputIp: Function;
    dataTable?: any;
    localShopId?: any;
    isConsult: boolean;
    setIsConsult: Function;
};

export function CashManagementConfigure({
    setIsAddCashManagementClicked,
    isAddCashManagementClicked,
    setDataIsUpdated,
    editedData,
    setEditedData,
    isAddNewCashManagementButtonClicked,
    shopId,
    setIsEdited,
    inputDesignation,
    setInputDesignation,
    inputMarque,
    setInputMarque,
    inputIp,
    setInputIp,
    dataTable,
    localShopId,
    isConsult,
    setIsConsult,
}: CashManagementType) {
    const {
        t,
        isActionsClicked,
        isEdited,
        designation,
        setDesignation,
        mark,
        setMark,
        remark,
        setRemark,
        reference,
        setReference,
        isNameExist,
        isModalOpened,
        setIsModalOpened,
        selectMark,
        data,
        pathname,
        notStartWithSpaceRegExp,
        matchWordDesignation,
        GloryReferencesArray,
        handleValidateButtonClickEvent,
        handleEditButtonClickEvent,
        activateCheckbox,
        uniqueDesignation,
        ipAddress,
        portNumber,
        user,
        password,
        posId,
    } = useCashManagementConfigure({
        setIsAddCashManagementClicked,
        isAddCashManagementClicked,
        setDataIsUpdated,
        editedData,
        setEditedData,
        isAddNewCashManagementButtonClicked,
        shopId,
        setIsEdited,
        inputDesignation,
        setInputDesignation,
        inputMarque,
        setInputMarque,
        inputIp,
        setInputIp,
        dataTable,
        localShopId,
        isConsult,
        setIsConsult,
    });

    return (
        <React.Fragment>
            <AvForm className="card">
                <CustomCardHeader
                    className="d-flex align-items-center justify-content-between"
                    style={{ maxHeight: "76px" }}
                >
                    <h5 className="pt-3 mon_txt_addCoinDevice">
                        {isConsult === true
                            ? t("View peripheral: coiners")
                            : editedData.length === 0
                            ? t("Add device: coiners")
                            : t("Modify a device: coiners")}
                    </h5>
                    <CrossIcon
                        style={{ cursor: "pointer" }}
                        className="mon_icn_closeForm"
                        height={13}
                        width={13}
                        onClick={() => {
                            if (isEdited === true) {
                                setIsActionsClicked(!isActionsClicked);
                                setActions(() => {
                                    resetAllPeripherals();
                                    setEditedData([]);
                                    setIsAddCashManagementClicked!(
                                        !isAddCashManagementClicked
                                    );
                                    setIsEdited(false);
                                    activateCheckbox();
                                    setIsConsult(false);
                                });
                            } else {
                                resetAllPeripherals();
                                setEditedData([]);
                                setIsAddCashManagementClicked!(
                                    !isAddCashManagementClicked
                                );
                                setIsEdited(false);
                                activateCheckbox();
                                setIsConsult(false);
                            }
                        }}
                    />
                </CustomCardHeader>
                <CustomCardBody
                    className="pl-3 pr-5"
                    style={{
                        maxHeight:
                            pathname === "/peripherals/cash-management"
                                ? "500px"
                                : "522px",
                        overflowY: " scroll",
                    }}
                >
                    <AvGroup>
                        <StyledLabel
                            className="required__clz mt-3"
                            htmlFor="name"
                        >
                            {t("Designation")}
                        </StyledLabel>
                        <StyledTextInput
                            className={classnames("mon_inp_name", {
                                input__clz:
                                    inputDesignation ||
                                    isNameExist ||
                                    (designation?.trim() === "" &&
                                        designation !== ""),
                                readOnly__clz: isConsult,
                            })}
                            autocomplete="off"
                            id="designation"
                            name="designation"
                            placeholder={t("Write")}
                            type="text"
                            onChange={(e: any) => {
                                setDesignation(e.target.value);
                                setIsEdited(true);
                                setInputDesignation(false);
                                uniqueDesignation(e.target.value);
                            }}
                            value={designation}
                            autoFocus={isConsult === true ? false : true}
                        />
                        {inputDesignation ||
                        (designation?.trim() === "" && designation !== "") ? (
                            <div
                                style={{
                                    width: "100%",
                                    marginTop: "0.25rem",
                                    fontSize: "80%",
                                    color: "#f46a6a",
                                }}
                            >
                                {t("Please enter a designation")}
                            </div>
                        ) : null}
                        {isNameExist ? (
                            <div
                                style={{
                                    width: "100%",
                                    marginTop: "0.25rem",
                                    fontSize: "80%",
                                    color: "#f46a6a",
                                }}
                            >
                                {t("The name is already exists")!}
                            </div>
                        ) : null}
                    </AvGroup>

                    <AvGroup>
                        <StyledLabel
                            className="required__clz mt-3"
                            htmlFor="mark"
                        >
                            {t("Mark")}
                        </StyledLabel>
                        {mark !== "" ? (
                            <StyledSelectInput
                                value={{
                                    label: mark,
                                    value: mark,
                                }}
                                className={classnames("mon_inp_mark", {
                                    invalid__clz: selectMark,
                                    readOnly__clz: isConsult,
                                    "not-allowed-input__clz":
                                        editedData.Id !== undefined,
                                })}
                                onChange={(e: any) => {
                                    setMark(e.value);
                                    setIsEdited(true);
                                    data.setIpAddress("");
                                    data.setPortNumber("");
                                    data.setUser("");
                                    data.setPassword("");
                                    data.setPosId("");
                                    e.value === "Cashdro"
                                        ? setReference("")
                                        : setReference("Monnayeur CI-5");
                                }}
                                options={[
                                    {
                                        label: "Glory",
                                        value: "Glory",
                                    },
                                    {
                                        label: "Cashdro",
                                        value: "Cashdro",
                                    },
                                ]}
                                validate={{
                                    required: {
                                        value: true,
                                        errorMessage: `${t(
                                            "Please select a mark"
                                        )!}`,
                                    },
                                }}
                                name="mark"
                                noOptionsMessage={() => t("No options")}
                            />
                        ) : (
                            <React.Fragment>
                                <StyledSelectInput
                                    className={classnames("mon_inp_mark", {
                                        invalid__clz: inputMarque,
                                        readOnly__clz: isConsult,
                                    })}
                                    placeholder={t("Select")}
                                    onChange={(e: any) => {
                                        data.setIpAddress("");
                                        data.setPortNumber("");
                                        data.setUser("");
                                        data.setPassword("");
                                        data.setPosId("");
                                        setMark(e.value);
                                        setIsEdited(true);
                                        e.value === "Cashdro"
                                            ? setReference("")
                                            : setReference("Monnayeur CI-5");
                                    }}
                                    options={[
                                        {
                                            label: "Glory",
                                            value: "Glory",
                                        },
                                        {
                                            label: "Cashdro",
                                            value: "Cashdro",
                                        },
                                    ]}
                                    validate={{
                                        required: {
                                            value: true,
                                            errorMessage: `${t(
                                                "Please select a mark"
                                            )!}`,
                                        },
                                    }}
                                    name="mark"
                                    noOptionsMessage={() => t("No options")}
                                    isClearable={true}
                                />
                                {inputMarque ? (
                                    <div
                                        style={{
                                            width: "100%",
                                            marginTop: "0.25rem",
                                            fontSize: "80%",
                                            color: "#f46a6a",
                                        }}
                                    >
                                        {t("Please select a mark")}
                                    </div>
                                ) : null}
                            </React.Fragment>
                        )}
                    </AvGroup>
                    {mark !== "" ? (
                        <AvGroup>
                            {mark === "Cashdro" ? (
                                <AvGroup>
                                    <StyledLabel
                                        className={`${
                                            mark === "Cashdro"
                                                ? ""
                                                : "required__clz"
                                        } mt-3`}
                                        htmlFor="reference"
                                    >
                                        {t("Reference")}
                                    </StyledLabel>

                                    <StyledTextInput
                                        onChange={(e: any) => {
                                            setReference(e.target.value);
                                            setIsEdited(true);
                                        }}
                                        placeholder={t("Write")}
                                        value={reference}
                                        name="reference"
                                        className={classnames(
                                            "mon_inp_reference",
                                            {
                                                readOnly__clz: isConsult,
                                            }
                                        )}
                                    />
                                </AvGroup>
                            ) : (
                                <AvGroup>
                                    <StyledLabel
                                        className="required__clz mt-3"
                                        htmlFor="reference"
                                    >
                                        {t("Reference")}
                                    </StyledLabel>

                                    <StyledSelectInput
                                        onChange={(e: any) => {
                                            setReference(e.value);
                                            setIsEdited(true);
                                        }}
                                        value={{
                                            label: reference,
                                            value: reference,
                                        }}
                                        options={GloryReferencesArray}
                                        name="reference"
                                        className={classnames(
                                            "mon_inp_reference",
                                            {
                                                readOnly__clz: isConsult,
                                            }
                                        )}
                                        noOptionsMessage={() => t("No options")}
                                    />
                                </AvGroup>
                            )}
                        </AvGroup>
                    ) : null}

                    <CashManagementConfiguration
                        data={data}
                        setDataIsUpdated={setIsEdited}
                        isEdited={isEdited}
                        setIsEdited={setIsEdited}
                        editedData={editedData}
                        localShopId={localShopId}
                        isConsult={isConsult}
                    />
                    <AvGroup>
                        <StyledLabel className="mt-3" htmlFor="remark">
                            {t("Remark")}
                        </StyledLabel>
                        <StyledTextInput
                            autocomplete="off"
                            className={classnames("mon_inp_remark", {
                                readOnly__clz: isConsult,
                            })}
                            id="remark"
                            name="remark"
                            placeholder={t("Write")}
                            type="text"
                            onChange={(e: any) => {
                                setRemark(e.target.value);
                                setIsEdited(true);
                            }}
                            value={remark}
                        />
                    </AvGroup>
                </CustomCardBody>
                <CustomCardFooter className="pt-1 pb-2">
                    <CustomSecondaryColorButton
                        outline
                        rounded
                        className="mr-2 mon_btn_cancel cmn_btn_cancel"
                        variant="light"
                        onClick={() => {
                            if (isEdited === true) {
                                setIsActionsClicked(!isActionsClicked);
                                setActions(() => {
                                    setEditedData([]);
                                    setIsAddCashManagementClicked!(
                                        !isAddCashManagementClicked
                                    );
                                    setIsEdited(false);
                                    setIsConsult(false);
                                    activateCheckbox();
                                });
                            } else {
                                setEditedData([]);
                                setIsAddCashManagementClicked!(
                                    !isAddCashManagementClicked
                                );
                                setIsEdited(false);
                                activateCheckbox();
                                setIsConsult(false);
                            }
                        }}
                    >
                        <span> {t("Cancel")}</span>
                    </CustomSecondaryColorButton>
                    <CustomMainColorButton
                        rounded
                        className={classnames(
                            "mon_btn_validate cmn_btn_validate",
                            {
                                "not-allowed-icon__clz": isConsult,
                            }
                        )}
                        variant="primary"
                        onClick={() => {
                            if (designation === "") {
                                setInputDesignation(true);
                            }
                            if (mark === "") {
                                setInputMarque(true);
                            }
                            if (mark !== "") {
                                if (portNumber === "") {
                                    data.setInputPort(true);
                                }
                                if (user === "") {
                                    data.setInputUser(true);
                                }
                                if (password === "") {
                                    data.setInputPassword(true);
                                }
                                if (posId === "") {
                                    data.setInputPosId(true);
                                }
                                if (ipAddress === "") {
                                    data.setEmptyIp(true);
                                }
                            }
                            if (
                                editedData.length === 0 &&
                                mark.length !== 0 &&
                                designation.length !== 0 &&
                                ipAddress.length !== 0 &&
                                portNumber.length !== 0 &&
                                !isNameExist &&
                                designation?.trim() !== "" &&
                                designation.match(notStartWithSpaceRegExp) &&
                                designation.match(matchWordDesignation) &&
                                ipAddress.match(ipMatchWord) &&
                                portNumber.match(numberMatchWord) &&
                                data.ipExist === false
                            ) {
                                if (
                                    mark === "Cashdro" &&
                                    posId.length !== 0 &&
                                    user.length !== 0 &&
                                    password.length !== 0 &&
                                    ipAddress.match(ipMatchWord)
                                ) {
                                    handleValidateButtonClickEvent();
                                } else if (mark === "Glory") {
                                    handleValidateButtonClickEvent();
                                }
                            } else if (
                                editedData.length !== 0 &&
                                mark.length !== 0 &&
                                designation.length !== 0 &&
                                ipAddress.length !== 0 &&
                                portNumber.length !== 0 &&
                                !isNameExist &&
                                designation?.trim() !== "" &&
                                designation.match(notStartWithSpaceRegExp) &&
                                designation.match(matchWordDesignation) &&
                                ipAddress.match(ipMatchWord) &&
                                data.ipExist === false
                            ) {
                                if (
                                    mark === "Cashdro" &&
                                    posId.length !== 0 &&
                                    user.length !== 0 &&
                                    password.length !== 0 &&
                                    ipAddress.match(ipMatchWord)
                                ) {
                                    if (
                                        editedData[t("Designation")] ===
                                            designation &&
                                        editedData[t("Reference")] ===
                                            reference &&
                                        editedData.Remark === remark &&
                                        editedData.server_directory ===
                                            data.logDirectory &&
                                        editedData.ip === ipAddress &&
                                        editedData.port_number === portNumber
                                    ) {
                                        setIsModalOpened(!isModalOpened);
                                    } else handleEditButtonClickEvent();
                                } else if (mark === "Glory") {
                                    if (
                                        editedData[t("Designation")] ===
                                            designation &&
                                        editedData[t("Reference")] ===
                                            reference &&
                                        editedData.ip === ipAddress &&
                                        editedData.port_number === portNumber &&
                                        editedData.Remark === remark &&
                                        editedData.server_directory ===
                                            data.logDirectory &&
                                        editedData.password === password &&
                                        editedData.user === user &&
                                        editedData.pos_id === posId
                                    ) {
                                        setIsModalOpened(!isModalOpened);
                                    } else handleEditButtonClickEvent();
                                }
                            }
                        }}
                    >
                        {t("Validate")}
                    </CustomMainColorButton>
                </CustomCardFooter>
            </AvForm>
            <ConfirmationEditMessage
                setDataIsUpdated={setDataIsUpdated}
                isModalOpened={isModalOpened}
                setIsModalOpened={setIsModalOpened}
                isAddClicked={isAddCashManagementClicked}
                setIsAddClicked={setIsAddCashManagementClicked}
                setEditedData={setEditedData}
            />
        </React.Fragment>
    );
}
